import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKModernMaterialsStone = () => (
  <ArticleWrapper articleId="gmk_modern_materials_stone">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Modern Materials Stone</h1>
        {/* Add your GMK Modern Materials Stone article content here */}
        <p>This is a placeholder article for the GMK Modern Materials Stone keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKModernMaterialsStone;
